import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import 'semantic-ui-css/semantic.min.css';
import HeaderTop from './components/header-top';
import Footer from './components/footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import App from "./App";


ReactDOM.render(

  <BrowserRouter>
    <App/>
  </BrowserRouter>,
  document.getElementById('root')
);

serviceWorker.unregister();
